








































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from "vuex-class";
import { pageDataType } from "../types";
import { HOST, API_URL } from "../global";
import axios from "axios";
@Component({
  name: "ManagementBlock",
})
export default class ManagementBlock extends Vue {
  @Prop() readonly compData!: any;
  public HOST: string = HOST;
  current = 0;
  count = 1;
  currentTab = 0;
  isCard: boolean = true;
  isTab: boolean = false;
  isManage: boolean = true;
  isShown: boolean = false;
  isShowing: boolean = false;
  isHide: boolean = true;
  tabdata: any[] = [];
  showHeader() {
    this.isManage = false;
    this.isShowing = !this.isShowing;
  }
  rmClass(index: any) {
    let d: any = document;
    var elm = d.querySelectorAll(".grid");

    for (var i = 0; i < elm.length; i++) {
      elm[i].classList.remove("mactive");
    }
  }
  showClick() {
    let d: any = document;
    var elm = d.querySelectorAll(".grid");

    for (var i = 0; i < elm.length; i++) {
      elm[i].classList.add("mactive");
    }
    window.scrollTo(0, 300);
    this.isManage = !this.isManage;
    this.isShown = !this.isShown;
  }
  created() {
    axios
      .get(`${API_URL}/pages/?&type=home.TabbedCollectionPage&fields=*`)
      .then((response) => {
        (this as any).tabdata = response.data;
      })
      .catch((e) => {
        (this as any).errors.push(e);
      });
  }
  
}
